/* tslint:disable */
/* eslint-disable */
/**
 * Webclipping
 * WebclippingのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateArticlePastSearchAutoRenewBody
 */
export interface UpdateArticlePastSearchAutoRenewBody {
    /**
     * 自動更新あり/なし
     * @type {boolean}
     * @memberof UpdateArticlePastSearchAutoRenewBody
     */
    isAutoRenewed: boolean;
}

export function UpdateArticlePastSearchAutoRenewBodyFromJSON(json: any): UpdateArticlePastSearchAutoRenewBody {
    return UpdateArticlePastSearchAutoRenewBodyFromJSONTyped(json, false);
}

export function UpdateArticlePastSearchAutoRenewBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateArticlePastSearchAutoRenewBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isAutoRenewed': json['is_auto_renewed'],
    };
}

export function UpdateArticlePastSearchAutoRenewBodyToJSON(value?: UpdateArticlePastSearchAutoRenewBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_auto_renewed': value.isAutoRenewed,
    };
}

